export default {
  section_title: 'Contact',
  v_html: ` <p class="description">My inbox is always open whether you have a question or want to say hi.<br />I will get back to you as soon as possible!</p>`,
  button: {
    text: 'Get in touch'
  }
};
